import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { shadowLight, borderTight } from 'app/colors';

export const ViewWrapper = styled.div`
  // This is the size of the bottom padding on EditableText.
  // They should match so that there is no jitter switching between text and the input.
  margin-bottom: -7px;
  .ViewText {
    margin-top: -1px;
    max-width: 100%;
  }

  input {
    min-width: 30px;
    padding-left: 0;
  }
  &&& input[disabled] {
    background: unset;
    // A bit blunt, but we need to make sure there's no image otherwise the background repeats
    background-image: none !important;
    color: var(--color-font-placeholder);
  }
  width: 100%;
`;

export const TextareaWrapper = styled.div`
  display: flex !important;
  flex-direction: column;
  align-items: flex-end;
  background: var(--color-background-white);
  margin-top: -20px;
  overflow: hidden;
  ${borderTight}
  ${shadowLight}
  > div:first-child {
    width: 100%;
    max-width: 100%;
    outline: none;
    border: none;
    resize: none;
    margin: 0;
    padding: 10px;
  }
  > div:first-child {
    padding-bottom: 0;
  }
  && > div > div > button {
    margin: 10px 1px 10px 5px;
    width: 12px;
  }

  ${({ width }) => css`
    width: ${width || 250}px;
  `}
`;
